module.exports = __webpack_public_path__ + "media/mms-tab-logo-mobile.17439376.svg";